<template>
  <div class="property_wrap">
    <div class="pro_top">选择地址设置</div>
    <div class="pro_con">
      <el-form ref="form" :model="property" label-width="80px">
        <el-form-item label="提示语:">
          <el-input v-model="property.name" maxlength="6" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="地址格式:">
          <el-radio-group v-model="property.radio">
            <el-radio :label="1">省-市-区-详细地址</el-radio>
            <el-radio :label="2">省-市-区</el-radio>
            <el-radio :label="3">省-市</el-radio>
            <el-radio :label="4">省</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
    };
  }
};
</script>
<style>
.el-radio{margin-right:20px}
</style>

 